<template>
  <path pid="0" d="M13 2a11 11 0 1011 11A11 11 0 0013 2zm0 2a9 9 0 015.62 2l-2.86 2.83a5 5 0 00-5.52 0L7.38 6A9 9 0 0113 4zm3 9a3 3 0 11-3-3 3 3 0 013 3zM4 13a9 9 0 012-5.62l2.86 2.86a5 5 0 000 5.52L6 18.62A9 9 0 014 13zm9 9a9 9 0 01-5.62-2l2.86-2.86a5 5 0 005.52 0L18.62 20A9 9 0 0113 22zm7-3.38l-2.86-2.86a5 5 0 000-5.52L20 7.38a9 9 0 010 11.24z"/>
</template>
